export default "__VITE_ASSET__DvB_QAW3__"